import * as React from "react";
import * as _ from "lodash";
import { Table } from "react-bootstrap";
import { IActionPosition } from "./models/action-position";
import SwapListRow from "./swap-list-row";
import styled from 'styled-components';
import { PreSelectReversalResponsible } from "@nkr/enums/preselect-reversal-responsible";

const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IProps {
    clusterNumber: number,
    positions: IActionPosition[],
    isMatchOffer: boolean,
    isCancelSwap: boolean,
    isCommencement: boolean,
    showStrongBox: boolean,
    hasPreselectReversal: boolean,
    onIncludeAll: (clusterNumber: number) => void,
    onClcColumnClick: () => void,
    onIncludeChange: (clusterNumber: number, positionNumber: number, include: boolean) => void,
    onIncludeClcChange: (clusterNumber: number, positionNumber: number, includeClc: number) => void,
    onReversalResponsibleChange: (clusterNumber: number, positionNumber: number, responsible: PreSelectReversalResponsible) => void
    onUseStrongBoxChange: (clusterNumber: number, positionNumber: number, useStrongBox: boolean) => void,
}

class SwapList extends React.Component<IProps, {}> {
    handleIncludeAll = () => {
        this.props.onIncludeAll(this.props.clusterNumber);
    }

    handleClcColumnClick = () => {
        this.props.onClcColumnClick();
    }

    handleIncludeChange = (positionNumber: number, include: boolean) => {
        this.props.onIncludeChange(this.props.clusterNumber, positionNumber, include);
    }

    handleUseStrongBoxChange = (positionNumber: number, useStrongBox: boolean) => {
        this.props.onUseStrongBoxChange(this.props.clusterNumber, positionNumber, useStrongBox);
    }

    handleIncludeClcChange = (positionNumber: number, includeClc: number) => {
        this.props.onIncludeClcChange(this.props.clusterNumber, positionNumber, includeClc);
    }

    handleReversalResponsibleChange = (positionNumber: number, responsible: PreSelectReversalResponsible) => {
        this.props.onReversalResponsibleChange(this.props.clusterNumber, positionNumber, responsible);
    }

    render = () => {
        const positions = _.orderBy(this.props.positions, (item: IActionPosition) => {
            return item.position.positionNumber
        });

        

        return (
            <>
                <TableWrapper condensed style={{ marginTop: 20 }}>
                    <thead>
                        <tr>
                            <th style={{ width: "12%" }}>Swap</th>
                            <th>Donor Center</th>
                            <th>Donor</th>
                            {this.props.hasPreselectReversal && this.props.isCancelSwap && (<th>PS Reversal (DC)</th>)}
                            <th>Recipient Center</th>
                            <th>Recipient</th>
                            {this.props.hasPreselectReversal && this.props.isCancelSwap && (<th>PS Reversal (RC)</th>)}
                            {this.props.isCommencement && (
                                <th>Data Complete</th>
                            )}


                            <th title="Include All/None" onClick={this.handleIncludeAll}>Include</th>
                            {this.props.showStrongBox && (<th title="Utilize Strong Box">Use SB</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {positions.map((item, index) =>
                            <SwapListRow
                                key={index}
                                index={index}
                                position={item.position}
                                include={item.include}
                                showStrongBox={this.props.showStrongBox}
                                useStrongBox={item.useStrongBox}
                                includeClc={item.includeClc}
                                responsible={item.responsible}
                                isMatchOffer={this.props.isMatchOffer}
                                isCommencement={this.props.isCommencement}
                                isCancelSwap={this.props.isCancelSwap}
                                hasPreselectReversal={this.props.hasPreselectReversal}
                                onIncludeChange={this.handleIncludeChange}
                                onIncludeClcChange={this.handleIncludeClcChange}
                                onReversalResponsibleChange={this.handleReversalResponsibleChange}
                                onUseStrongBoxChange={this.handleUseStrongBoxChange}
                            />
                        )}
                    </tbody>
                </TableWrapper>
            </>
        );
    }
}

export default SwapList;